document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.modal').forEach(modal => {
		const iframe = modal.querySelector('iframe');

		if (!iframe) return;

		modal.addEventListener('modal:close', () => {
			const src = iframe.getAttribute('src');
			iframe.setAttribute('src', src);
		});
	});
});
